import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { env } from './env'
import { PlayerErrorBoundary } from './screens/player-error-boundary'
import './theme/index.css'
import { sanitizeSentryBreadcrumb, sanitizeSentryEvent } from './utils/sentry-redaction'

if (env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    release: env.VITE_PLAYER_RELEASE,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
      Sentry.browserTracingIntegration()
    ],
    enableLogs: true,
    sendDefaultPii: false,
    beforeSend: sanitizeSentryEvent,
    beforeBreadcrumb: sanitizeSentryBreadcrumb,
    // 10% das transações — suficiente para detectar regressão de performance sem estourar quota
    tracesSampleRate: 0.1
  })
}

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

createRoot(root).render(
  <StrictMode>
    <PlayerErrorBoundary>
      <App />
    </PlayerErrorBoundary>
  </StrictMode>
)
